import { Spinner } from 'components';
const Loading = () => (
   <div className='bg-[#ffffff] dark:bg-[#2E2D2D] items-center cursor-progress flex h-full w-full justify-center rounded-[20px]'>
      <Spinner />
   </div>
);
export default Loading;
